import React from 'react';
import {useTranslation} from 'react-i18next';

import {IconCheck} from '../../assets';
import {Button} from '../Button/Button';

import './PriceCard.css';

export type Pricing = {
    cardIndex: number;
    key: string;
    title: string;
    price: string;
    equivalent: string;
    perSeason: string;
    priceDesc: string;
    skuLimit: string;
    researchTheme: string;
    descriptionItems: string[];
    postFix?: string;
}

export interface Props extends Pricing {
    onClick: () => void;
}

export const PriceCard: React.FC<Props> =
    ({
         cardIndex,
         title,
         price,
         perSeason,
         priceDesc,
         equivalent = null,
         skuLimit = null,
         researchTheme,
         descriptionItems,
         onClick,
         postFix
     }) => {
        const {t} = useTranslation();

        return (
            <div className={`PriceCard ${cardIndex === 3 ? 'PriceCard-half' : ''}`} onClick={onClick}>
                <div className="PriceCard-header">
                    <span className="PriceCard-text PriceCard-title">{title}</span>
                    <span>
                        <strong className="PriceCard-text-bold">{price}</strong>&nbsp;<span
                        className="PriceCard-text PriceCard-seasontext">{perSeason}</span>
                    </span>
                    {!!priceDesc && <span className="PriceCard-text PriceCard-seasondesc">{priceDesc}</span>}

                    {!!equivalent && <span className="PriceCard-equivalent">{equivalent}</span>}
                    {!!researchTheme && <span className="PriceCard-text">{researchTheme}</span>}
                    {!!skuLimit && <span className="PriceCard-skuLimit">{skuLimit}</span>}
                </div>
                <div className="PriceCard-divider"/>
                <div className="PriceCard-content">
                    {descriptionItems?.length > 0 && (
                        <ul className="PriceCard-list">
                            {descriptionItems.map((item, index) => (
                                <li className="PriceCard-list-element" key={index}>
                                    <div className="PriceCard-dot">
                                        <IconCheck className="PriceCard-check"/>
                                    </div>
                                    <span className="PriceCard-text"
                                          dangerouslySetInnerHTML={{ __html: item }}
                                    ></span>
                                </li>
                            ))}
                        </ul>
                    )}
                    {!!postFix && (
                        <span className="PriceCard-list-postfix">
                        {postFix}
                    </span>
                    )}
                </div>
                <Button full disableHover>{t('common.selectButton')}</Button>
            </div>
        );
    };
